export default "__VITE_ASSET__D0WYJDsB__"